<template>
<div class="animated fadeIn mt-5" v-if="dataLoaded">
  <form enctype="multipart/form-data" v-on:submit="validateBeforeSubmit($event,false)">
    <div class="row">
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong>Importar Stars WS Relations</strong>
          </div>
          <b-form-row>
            <b-form-group class="col-sm-4" label="Apagar actuais">
              <b-form-select :options="lists.yesNo" name="deletePrevious" v-model="item.deletePrevious" placeholder="Apagar actuais"  v-validate="'required'" :state="validateState('deletePrevious')" ></b-form-select>
              <b-form-invalid-feedback>
                {{ errors.first('deletePrevious') }}
              </b-form-invalid-feedback>
            </b-form-group>
            <b-form-group label="Desde: Ano / Mês" v-if="item.deletePrevious==1">
              <b-form-input type="number" step="1" min="201900" name="deleteFrom" v-model="item.deleteFrom" placeholder="2019XX"  v-validate="'required'" :state="validateState('deleteFrom')"></b-form-input>
              <b-form-invalid-feedback>
                {{ errors.first('deleteFrom') }}
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-row>
          <p>Copiar objectivos no campo abaixo, separador por TAB<br><br>
            ano/mês
            <span class="text-danger">TAB</span> ano/mes inicial
            <span class="text-danger">TAB</span> ano/mes final
            <span class="text-danger">TAB</span> shipto
            <span class="text-danger">TAB</span> codigo zona
            <span class="text-danger">TAB</span> so
            <span class="text-danger">TAB</span> st
            <span class="text-danger">TAB</span> cadv
            <span class="text-danger">TAB</span> cha
          </p>
          <b-form-group>
            <b-form-textarea name="objectives" rows="20" v-model="item.objectives" v-validate="'required'" :state="validateState('objectives')"></b-form-textarea>
            <b-form-invalid-feedback>
              {{ errors.first('objectives') }}
            </b-form-invalid-feedback>
          </b-form-group>


          <div slot="footer">
            <div class="row">
              <div class="col-sm-3">
                <router-link :to="{name:'criteria.index'}" size="sm" variant="danger"><i class="fa fa-ban"></i> Cancelar</router-link>

              </div>
              <div class="col-sm-9 text-right">
                <b-button type="submit" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar</b-button>
                <b-button type="button" v-on:click="validateBeforeSubmit($event,true)" size="sm" variant="primary"><i class="fa fa-save"></i> Gravar e fechar</b-button>
              </div>
            </div>
          </div>
        </b-card>


      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong>Debug </strong>
          </div>
          <pre>{{ item }}
          </pre>

        </b-card>
      </b-col>
      <!--/.col-->
    </div>
  </form>

</div>
</template>

<script>
import lists from '@/components/States.js'
export default {
  name: 'ImportCriteria',
  props: ['id'],
  components: {},
  data() {
    return {
      lists: lists,
      item: {
        objectives:'',
        deletePrevious: 0,
        deleteFrom: ''
      }
    }
  },
  methods: {
    validateBeforeSubmit(evt, close) {
      evt.preventDefault()
      console.log('check validation')
      this.$validator.validateAll().then((result) => {
        console.log('validation results:', result)
        if (result) {
          console.log('all fields ok. submit')
          this.submit(evt, close)
          return
        }
        this.$bvToast.toast(`Tem campos inválidos`, { autoHideDelay: 5000, variant: 'danger', solid: true })
      })
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    submit(e, close) {
      e.preventDefault()
      var data = {
        data: this.item
      }
      this.axios.post('stars/ws_relations/import', data)
        .then(response => {
          this.$bvToast.toast('WS Relations imporados com sucesso', { autoHideDelay: 5000, variant: 'success', solid: true })          
          this.item = {
            objectives:'',
            deletePrevious: 0,
            deleteFrom: ''
          }
        })
        .catch(response => {
          this.$bvToast.toast(`Não foi possivel gravar`, { autoHideDelay: 5000, variant: 'danger', solid: true })
        })
    }
  },
  created() {
    this.dataLoaded = true
  }
}
</script>
